module.exports = __webpack_public_path__ + "img/onboarding_guide3.d86432ed.jpeg";